import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecd31a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "borrow-applyDetail" }
const _hoisted_2 = { class: "sign-table-wrapper" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { decproDetail } from "@/api/process";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }





watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

onMounted(async () => {
  getdata();
});

const getdata = async () => {
  const { Data } = await decproDetail({
    Id: props.folwId,
    IsApproveDetail: 1,
  });
  tableData.value = [
    ...((Data?.PageFiles.length > 0 && Data?.PageFiles) || []),
    ...((Data?.BackPageFiles.length > 0 && Data?.BackPageFiles) || []),
  ];
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "装修、采购协议申请",
      style: {"margin-top":"24px"}
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})